module.exports = __webpack_public_path__ + "static/media/recenter-icon.b08048b5.svg";